export default {
  // 批量分配割草机
  updateMowingInfo: '/business/jgMowingInfo/updateMowingInfo',
  // 割草机修改名称
  updateMowingInfoLocation: '/business/jgMowingInfo/updateMowingInfoLocation',
  // 割草机时间段配置
  insertMowingCuttime: '/business/jgMowingInfo/insertMowingCuttime',
  // 发送割草机指令
  insertMowingInstructions: '/business/jgMowingInfo/insertMowingInstructions',
  // 同步时间
  insertMowingTime: '/business/jgMowingInfo/insertMowingTime',
  // 同步数据
  insertMowingData: '/business/jgMowingInfo/insertMowingData',
  // 查询割草机详情
  selectJgMowingInfoByDeviceNumber: '/business/jgMowingInfo/selectJgMowingInfoByDeviceNumber',
  // 查询割草机列表
  selectJgMowingInfoMapByList: '/business/jgMowingInfo/selectJgMowingInfoMapByList',
  // 查询割草机项目列表
  selectProjectMowingByList: '/business/jgMowingInfo/selectProjectJgMowingByList',
  // 查询割草机地图列表
  selectSumecConfigMapByList: '/business/jgMowingInfo/selectSumecConfigMapByList',
  // 切换割草机地图
  insertSumecInstructionsMap: '/business/jgMowingInfo/insertSumecInstructionsMap',
  // 查询割草机地图
  selectJgMowingInfoMapByList: '/business/jgMowingInfo/selectJgMowingInfoMapByList'
}
